import * as CONST from '../ActionTypes';
import * as util from './util';

/**
 * 商品一覧
 */
export const getProductList = (companyId, limit, offset) => (dispatch) => fetch(
  `${process.env.REACT_APP_ENDPOINT}/api/v1/products/with_customer/${companyId}?limit=${limit}&offset=${offset}`,

  {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    mode: 'cors',
  },
)
  .then((response) => response.json())
  .then((payload) => {
    dispatch(util.actionType(CONST.GET_PRODUCT_LIST_SUCCESS, payload));
  })
  .catch((error) => {
    dispatch(util.actionType(CONST.GET_PRODUCT_LIST_FAILURE, error));
  });

/**
 * 商品詳細取得
 */
export const getProductDetail = (id) => (dispatch) => fetch(
  // eslint-disable-next-line no-undef
  `${process.env.REACT_APP_ENDPOINT}/api/v1/products/${id}`,
  {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    mode: 'cors',
  },
)
  .then((response) => response.json())
  .then((payload) => {
    dispatch(util.actionType(CONST.GET_PRODUCT_DETAIL_SUCCESS, payload));
  })
  .catch((error) => {
    dispatch(util.actionType(CONST.GET_PRODUCT_DETAIL_FAILURE, error));
  });
